import Autocomplete from "@mui/material/Autocomplete";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import React from "react";
import { store } from "../store";

export interface OfficePullDownState {
    selectedOfficeId?: number | null;
    onChange: (officeId: number) => void;
    useAllOfficeIds: boolean;
}

interface Office {
    officeId: number;
    name: string;
}

export const OfficePullDown: React.FC<
    OfficePullDownState & { className?: string; m?: number }
> = (props: OfficePullDownState) => {
    const officeIds = store.getState().common.officeIds;
    const officeNames = store.getState().common.officeNames;

    const selectedOfficeId: number = props.selectedOfficeId
        ? props.selectedOfficeId
        : -1;
    const offices: Array<Office> = [];

    let selectedOffice = {
        officeId: -1,
        name: "",
    };
    if (props.useAllOfficeIds) {
        if (officeNames && officeNames.length > 0) {
            const item = { officeId: -1, name: "全ての営業所" };
            offices.push(item);
            selectedOffice = item;
        }
    }
    for (let i: number = 0; i < officeIds.length; ++i) {
        const item = { officeId: officeIds[i], name: officeNames[i] };
        offices.push(item);
        if (officeIds[i] === selectedOfficeId) {
            selectedOffice = item;
        }
    }

    const defaultProps = {
        options: offices,
        getOptionLabel: (option: any) => option.name,
    };

    return (
        <Stack spacing={1} sx={{ width: 240 }}>
            <Autocomplete
                value={selectedOffice}
                {...defaultProps}
                onChange={(ev, newVal) => {
                    props.onChange(newVal.officeId);
                }}
                title="営業所名"
                clearOnEscape
                disableClearable={true}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="営業所選択"
                        size="small"
                        variant="filled"
                        inputProps={{
                            ...params.inputProps,
                        }}
                    />
                )}
            />
        </Stack>
    );
};
